import { Cirus } from "@/classes/Http";
import { AxiosResponse } from "axios";
import { InstanceAccess } from "../Commands";

export enum UserAccessEnum {
        inventory='inventory',
        boughtTransaction='boughtTransaction',
        soldTransaction='soldTransaction',
        incomeTransaction='incomeTransaction',
        costTransaction='costTransaction',
        returnSoldTransaction='returnSoldTransaction',
        returnBoughtTransaction='returnBoughtTransaction',
        transferTransaction='transferTransaction',
        boughtInvoice='boughtInvoice',
        soldInvoice='soldInvoice',
        incomeInvoice='incomeInvoice',
        costInvoice='costInvoice',
        returnSoldInvoice='returnSoldInvoice',
        returnBoughtInvoice='returnBoughtInvoice',
        transferInvoice='transferInvoice',
        customer='customer',
        crm='crm',
        insight='insight',
        media='media',
        setting='setting',
}

export function getUserInstancePermissions(instance_id: number): Promise<AxiosResponse<InstanceAccess>> {
    const path = `/instance/${instance_id}/my-permissions`;
    return Cirus.get(path);
}